export interface Testimonial {
  name: string;
  postcode: string;
  quote: string;
  rating: number;
  platform: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "Rachel M.",
    postcode: "N1, Islington",
    quote:
      "Turned up on time, fixed our tripping fuse box and left the place tidier than he found it. Clear pricing from the start.",
    rating: 5,
    platform: "Google Reviews",
  },
  {
    name: "Daniel P.",
    postcode: "N5, Highbury",
    quote:
      "Sorted the lighting in our small café before opening. Friendly, calm, quick — exactly the kind of local trade you want.",
    rating: 5,
    platform: "Checkatrade",
  },
  {
    name: "Priya S.",
    postcode: "N7, Holloway",
    quote:
      "Landlord EICR done the next day. Report was clear, easy to read, and he walked me through everything patiently.",
    rating: 5,
    platform: "Google Reviews",
  },
];

export const trustStats = [
  { value: "12+", label: "Years working across North London" },
  { value: "1,400+", label: "Local jobs completed" },
  { value: "4.9", label: "Average local rating" },
];